import React from 'react';
import styles from './styles.module.css';
const Select = ({  name, data, placeholder }) => {
  return (
    <div className={styles.checkBox}>
      <select name={name} defaultValue={"1"}>
        <option value="1" disabled>{placeholder}</option>
        {
        data
        ?
        data.map((x)=>{
            return <option value={x}>{x}</option>
        })
        :
        ''
    }
      </select>
    </div>
  );
};

export default Select;